import { Component } from '@angular/core';
import { AuthService } from '../../../../../core/services/authentication/auth.service';
import {
  Router,
  NavigationEnd,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { WebService } from '../../../../../core/services/web-service/web.service';
import { UtilityHelper } from '../../../../../core/helper/utility-helper';
import { UserManagementService } from '../../../../../core/services/user/user-management.service';
import { environment } from '../../../../../../environments/environment';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-sitebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './sitebar.component.html',
  styleUrl: './sitebar.component.scss',
})
export class SitebarComponent {
  currentUserId: any;
  isLoading: boolean = true;
  DataList: any = '';
  imageBaseUrl = environment.imageBaseUrl;
  siteBarshowHide = false;
  activeTab: string = '';
  constructor(
    private authService: AuthService,
    private WebService: WebService,
    private UserService: UserManagementService,
    private router: Router,
    private utility: UtilityHelper
  ) {
    this.activeTab = this.router.url;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeTab = this.router.url;
      }
    });
  }
  // logout() {
  //   this.WebService.triggerReload();
  //   this.authService.logout();
  // }
  ngOnInit() {
    this.getCurrentUser();
    this.WebService.userProfileReload$.subscribe(() => {
      this.fetchProfileData();
    });
    this.UserService.profileData$.subscribe((data) => {
      if (data) {
        this.DataList = this.DataList.map((profile: any) => {
          if (profile.id == data.id) {
            return (profile = data); // Merge the updated profile data
          }
          return profile;
        });
      }
      this.fetchProfileData();
    });
  }
  classShow() {
    this.siteBarshowHide = true;
  }
  classHide() {
    this.siteBarshowHide = false;
  }
  getCurrentUser(): void {
    const currentUserId = this.authService.userId;
    const token = this.authService.authToken;
    if (currentUserId) {
      this.currentUserId = this.authService.userId;
      // this.authToken = this.authService.authToken;
    } else {
      this.currentUserId = null;
    }
  }

  fetchProfileData() {
    const payload = {
      user_id: this.currentUserId,
    };
    this.UserService.userProfile(payload).subscribe({
      next: (res: any) => {
        if (res.status === 200 && res.data) {
          this.DataList = res?.data;
        } else {
          // this.DataList = [];
        }
        this.UserService.profileDataData(res);
      },
      error: (error: any) => {
        this.utility.toastAlert('error', error.message || 'An error occurred');
      },
    });
  }
}
